
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/invest_gift",
      function () {
        return require("private-next-pages/invest_gift.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/invest_gift"])
      });
    }
  